<template>
    <v-container>
        <v-layout
        text-center
        wrap
        >
            <v-card
            class="mx-auto"
            width="100%"
            >
            <v-toolbar
                color="secondary"
                dark
            >
                <v-toolbar-title>Treatment Reference</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn color="primary" icon>
                <v-icon>mdi-magnify</v-icon>
                </v-btn>
            </v-toolbar>

            <v-expansion-panels accordion>
                <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                    <v-col cols="4">Filter</v-col>
                        <v-col
                        cols="8"
                        class="text--secondary"
                        >
                           <template v-slot:default="{ open }">
                                <v-fade-transition leave-absolute>
                                    <span
                                    v-if="open"
                                    key="0"
                                    >
                                    Select Filter Options
                                    </span>
                                    <span
                                    v-else
                                    key="1"
                                    >
                                    Sort By: {{ filterOptions.sortBy }}
                                    </span>
                                </v-fade-transition>
                            </template>
                        </v-col>
                    <template v-slot:actions>
                        <v-icon color="primary">mdi-filter-menu</v-icon>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    Some random filtering options

                    <v-row no-gutters>
                        <v-spacer></v-spacer>
                        <v-col cols="5">
                        <v-select
                            v-model="filterOptions.sortBy"
                            :items="sortOptions"
                            flat
                        ></v-select>
                        </v-col>

                        <v-divider
                        vertical
                        class="mx-4"
                        ></v-divider>

                        <v-col cols="3">
                        Refine your treatment search using the filtering options
                        <br>
                        <a href="javascript:void(0)">Learn more</a>
                        </v-col>
                    </v-row>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        text
                        color="secondary"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                        text
                        color="primary"
                        >
                            Update
                        </v-btn>
                    </v-card-actions>
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-list two-line subheader>

                <v-list-item
                v-for="item in items"
                :key="item.title"
                link
                >

                <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-icon>
                    <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>

                <v-list-item-icon>
                    <v-icon>mdi-file-find</v-icon>
                </v-list-item-icon>

                </v-list-item>
            </v-list>
            </v-card>

        </v-layout>
    </v-container>

</template>

<script>
export default {
    name: 'treatmentReferencePage',
    components: {

    },
    data: () => ({
        filterOptions: {
            sortBy: null
        },
        sortOptions: ['Newest', 'Most Popular', 'A-Z Ascending', 'A-Z Descending'],
        items: [
        { title: 'DentalTreatment1', subtitle: '-05/02/2020'},
        { title: 'SomeDentalTreatment', subtitle: '-02/02/2020'},
    ]
    })
}
</script>
